import React from "react";
import { useAuth } from "react-oidc-context";
import logo from "./innvo-lockup-cream.svg";

import ValidationCheckPage from "./components/validationcheck/ValidationCheckPage";

function App() {
  const auth = useAuth();

  if (auth.isLoading) {
    return <div>Carregando...</div>;
  }

  if (auth.error) {
    return <div>Encountering error... {auth.error.message}</div>;
  }

  return (
    <div className="app-container">
      <header className="header">
        <div className="logo">
          <img src={logo} alt="Innvo Labs" />
        </div>
        {auth.isAuthenticated && (
          <button className="header-signout" onClick={() => auth.removeUser()}>
            Sair
          </button>
        )}
      </header>

      <div className="content">
        {!auth.isAuthenticated ? (
          <div className="auth-buttons">
            <button onClick={() => auth.signinRedirect()}>Entrar</button>
          </div>
        ) : (
          <ValidationCheckPage />
        )}
      </div>
    </div>
  );
}

export default App;
